import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Grid, Row, Col } from 'react-bootstrap';

import AccountSettingsSideMenu from '../../components/AccountSettingsSideMenu';
import DeleteUserForm from '../../components/DeleteUser/DeleteUserForm';

import s from './deleteUser.css';

const DeleteUser = () => {

    return (
        <>
            <Grid fluid className={'dashBoardContainer'}>
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className={'dashBoardListingGrid'}>
                            <AccountSettingsSideMenu />
                            <DeleteUserForm />
                        </div>
                    </Col>
                </Row>
            </Grid>
        </>
    );
}

export default withStyles(s)(DeleteUser);
